module.exports = __webpack_public_path__ + "img/love-bn-01.e2dc1e88.jpg";